import { Button as MantineButton } from "@mantine/core";

const Button = ({
  children,
  onClick,
  loading,
  disabled,
  id,
  leftSection,
  rightSection,
  ariaLabel,
  type,
  fullWidth,
  styles,
  className,
  isExport,
  isFilter,
  ...restProps
}) => {
  return (
    <MantineButton
      loading={loading}
      leftSection={leftSection}
      rightSection={rightSection}
      onClick={onClick}
      disabled={disabled}
      id={id}
      aria-label={ariaLabel}
      type={type}
      fullWidth={fullWidth || false}
      styles={
        isFilter
          ? {
              root: {
                height: 37.5,
                width: !fullWidth ? "50%" : "100%",
              },
            }
          : styles
          ? { ...styles }
          : {}
      }
      className={isFilter ? `my-auto mt-2 ${className}` : className || ""}
      {...restProps}
    >
      {children}
    </MantineButton>
  );
};

export default Button;
